import {
  CrudFilters,
  HttpError,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  BooleanField,
  Button,
  Col,
  Collapse,
  DeleteButton,
  EditButton,
  Form,
  FormProps,
  Icons,
  Input,
  List,
  Row,
  Select,
  Space,
  Table,
  useSelect,
  useTable,
} from "@pankod/refine-antd";

import {
  ISpecie,
  ISubSpecie,
  ISubSpeciesFilterVariables,
} from "../../interfaces";

const { CloseCircleOutlined, CheckCircleOutlined } = Icons;

const Filter: React.FC<{ formProps: FormProps }> = ({ formProps }) => {
  const { selectProps: speciesSelectProps } = useSelect<ISpecie>({
    resource: "species",
    optionLabel: "name",
    sort: [{ field: "name", order: "asc" }],
  });

  const { Panel } = Collapse;

  return (
    <Collapse style={{ marginBottom: 10 }} defaultActiveKey={["1"]}>
      <Panel
        header={
          <>
            <Icons.FilterOutlined style={{ marginRight: 10 }} />
            Filters
          </>
        }
        key="1"
        showArrow={false}
      >
        <Form layout="vertical" {...formProps}>
          <Row>
            <Col xs={12} className={"filtersCol"}>
              <Form.Item label="Search" name="q">
                <Input
                  placeholder="ID, Name, Common name, etc."
                  prefix={<Icons.SearchOutlined />}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={12} className={"filtersCol"}>
              <Form.Item label="Species" name="species">
                <Select
                  {...speciesSelectProps}
                  allowClear
                  placeholder="Search Species"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className={"filtersCol"}>
              <Form.Item>
                <Button htmlType="submit" type="primary">
                  Filter
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
};

export const SubSpecieList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, searchFormProps } = useTable<
    ISubSpecie,
    HttpError,
    ISubSpeciesFilterVariables
  >({
    metaData: {
      populate: ["specie"],
    },
    initialSorter: [
      {
        field: "specie.name",
        order: "asc",
      },
    ],
    onSearch: (params) => {
      const filters: CrudFilters = [];
      const { q, species } = params;

      filters.push(
        {
          field: "_q",
          operator: "eq",
          value: q,
        },
        {
          field: "specie.id",
          operator: "eq",
          value: species,
        }
      );

      return filters;
    },
  });
  return (
    <List>
      <Filter formProps={searchFormProps} />
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="id" title="ID" />
        <Table.Column
          dataIndex={["specie", "data", "attributes", "name"]}
          title="Specie"
        />
        <Table.Column
          dataIndex="name"
          title="Name (spp. if absent)"
          render={(value) => {
            if (value === "") return "spp.";
            return value;
          }}
        />
        <Table.Column
          title="Enabled"
          dataIndex={"enabled"}
          render={(value) => {
            return (
              <BooleanField
                value={value}
                trueIcon={<CheckCircleOutlined />}
                falseIcon={<CloseCircleOutlined />}
                valueLabelTrue="Si"
                valueLabelFalse="No"
              />
            );
          }}
          align="center"
        />
        <Table.Column
          title="Junior"
          dataIndex={"junior"}
          render={(value) => {
            return (
              <BooleanField
                value={value}
                trueIcon={<CheckCircleOutlined />}
                falseIcon={<CloseCircleOutlined />}
                valueLabelTrue="Si"
                valueLabelFalse="No"
              />
            );
          }}
          align="center"
        />
        <Table.Column<ISubSpecie>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              {/* <ShowButton size="small" hideText recordItemId={record.id} /> */}
              <EditButton size="small" hideText recordItemId={record.id} />
              <DeleteButton size="small" hideText recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
